var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClauseCheckNewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3163_400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3163_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42313 17.0834C4.00215 17.0834 3.64583 16.9376 3.35417 16.6459C3.0625 16.3542 2.91667 15.9979 2.91667 15.577V4.42321C2.91667 4.00223 3.0625 3.64591 3.35417 3.35425C3.64583 3.06258 4.00215 2.91675 4.42313 2.91675H13.1571L17.0833 6.843V15.577C17.0833 15.9979 16.9375 16.3542 16.6458 16.6459C16.3542 16.9376 15.9978 17.0834 15.5769 17.0834H4.42313ZM6.04167 13.7501H13.9583V12.5001H6.04167V13.7501ZM6.04167 10.6251H13.9583V9.37508H6.04167V10.6251ZM12.5 7.50008H15.8333L12.5 4.16675V7.50008ZM6.04167 7.50008H10V6.25008H6.04167V7.50008Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClauseCheckNewActive);
export default __webpack_public_path__ + "static/media/clauseCheckNewActive.e49f6234bf9bd979cc55ac3ce3edc5aa.svg";
export { ForwardRef as ReactComponent };